document.querySelector('#contact-form').addEventListener('submit', function(event) {handleSubmit(event)});

function handleSubmit(event)
{
    //Hide any existing errors
    document.querySelector('.error-display').classList.remove('show');

    //Prevent form submitting anywhere
    event.preventDefault();
    let error = false;
    
    //Get & Validate name
    let name = document.querySelector('#name').value
    if (name.length < 1) {
        displayError('Please enter a valid name.');
        error = true;
    }
    //Get & Validate email
    let email = document.querySelector('#email').value;
    if (!validateEmail(email)) {
        displayError('Please enter a valid email.')
        error = true;
    }

    //Get & Validate message
    let message = document.querySelector('#message').value;
    if (message.length < 5)
    {
        displayError('Please provide a message');
        error = true;
    }

    if (error)
    {
        return;
    }

    //Hide the form inputs
    document.querySelector('.input-container').classList.add('hidden');

    //Show the loading spinner
    document.querySelector('.progress-container').classList.remove('hidden');

    //Submit to sailthru to trigger a send
    Sailthru.integration('customEvent', {
        "name" : "corporateEnquiry",
        "email" : 'richard.stebbing@theteachco.com',
        "vars" : {
            "name" : name,
            "email" : email,
            "message" : message
        },
        "onSuccess" : success,
        "onError" : sailthruError
    })
    return false;
}

function sailthruError()
{
    //Hide the progress spinner,
    //Show the form again,
    //And display an error to the user

    document.querySelector('.progress-container').classList.add('hidden');

    document.querySelector('.input-container').classList.remove('hidden');

    displayError('An error occurred while trying to submit your message, please try again.')
}

function success()
{
    //Hide the loading spinner &
    //Show a success message
    document.querySelector('.lds-ring').classList.add('hide');
    document.querySelector('.output').innerHTML = 'Your Message Has Been Sent.'

    
    document.querySelector('.check-mark').style.display = 'block';

    //Slide in animation effect for check mark
    setTimeout( function() {
        document.querySelector('.check-mark').classList.remove('hidden');
    }, 500);
    

}

//Writes an error to the p tag under the form 
//and displays it
function displayError(message)
{
    let errorElement = document.querySelector('.error-display');

    errorElement.innerHTML = message;
    errorElement.classList.add('show');
}

//Basic email verification if the 'required' field breaks
//for whatever reason
function validateEmail(email)
{
    if (email.indexOf('@') != -1 && email.length > 8)
    {
        return true;
    }
    return false;
}